/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weird_Keen_Reindeer_DialInputs */

const fr_weird_keen_reindeer_dial = /** @type {(inputs: Weird_Keen_Reindeer_DialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produit`)
};

/**

* @param {Weird_Keen_Reindeer_DialInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weird_keen_reindeer_dial = /** @type {((inputs?: Weird_Keen_Reindeer_DialInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weird_Keen_Reindeer_DialInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weird_keen_reindeer_dial(inputs)
});